module.exports = __webpack_public_path__ + "img/dta.1229d798.svg";